module.exports = __webpack_public_path__ + "img/contract-expire-2.5729fca1.svg";